export default "__VITE_ASSET__vpqV4Aji__"